// ExcelController — 분리앱(브라우저) 환경.
// exceljs는 브라우저 빌드로 번들되어 workbook/buffer 생성을 담당하고,
// 실제 파일 쓰기는 IPC로 일렉트론에 위임.
import Excel from 'exceljs'
import { ipcRenderer } from 'electron' // vue.config alias -> electronStub

class ExcelController {
    constructor() {
        this.workbook = new Excel.Workbook()
    }
    _applyCellStyle(cell, styles) {
        Object.assign(cell.style, styles)
    }

    setupWorkSheet(worksheetName) {
        if (!this.workbook) return null
        let worksheet = this.workbook.getWorksheet(worksheetName)
        if (worksheet) {
            this.workbook.removeWorksheet(worksheet.id)
            worksheet = this.workbook.addWorksheet(worksheetName)
        } else {
            worksheet = this.workbook.addWorksheet(worksheetName)
        }
        return worksheet
    }

    async getFileBuffer() {
        if (!this.workbook) return null
        return await this.workbook.xlsx.writeBuffer()
    }

    async saveFile(title, fileName, worksheet) {
        if (!this.workbook) return false
        try {
            const buffer = await this.getFileBuffer()
            const filters = [{ name: 'Excel Files', extensions: ['xlsx'] }]

            // 메인이 저장 다이얼로그 표시 + 파일쓰기까지 처리 (file로 buffer 동봉)
            const savedPath = await new Promise((resolve, reject) => {
                ipcRenderer.send('Application.openFileSaveDialog', { title, fileName, filters, file: buffer })
                ipcRenderer.once('Application.fileSaveDialogResult', (_, path) => {
                    path ? resolve(path) : reject(new Error('File save cancelled.'))
                })
            })
            return !!savedPath
        } catch (error) {
            console.error('Error saving file:', error)
            return false
        } finally {
            if (worksheet && this.workbook) {
                this.workbook.removeWorksheet(worksheet.id)
            }
        }
    }

    mergeCells(worksheet, startRow, startCol, endRow, endCol) {
        if (!worksheet) return
        worksheet.mergeCells(startRow, startCol, endRow, endCol)
    }

    canMergeCells(worksheet, startRow, startCol, endRow, endCol) {
        if (!worksheet) return false
        const mergeRange = worksheet._merges

        for (let key in mergeRange) {
            if (!Object.prototype.hasOwnProperty.call(mergeRange, key)) continue

            const [cellStart, cellEnd] = key.split(':')
            const [startCellRow, startCellCol] = this._parseCell(cellStart)
            const [endCellRow, endCellCol] = this._parseCell(cellEnd)

            if (!(startRow > endCellRow || endRow < startCellRow || startCol > endCellCol || endCol < startCellCol)) {
                return false
            }
        }

        return true
    }

    _parseCell(cell) {
        if (!cell) return [null, null]
        const match = cell.match(/([A-Z]+)(\d+)/)
        if (!match) return [null, null]
        const col = match[1].split('').reduce((acc, char) => acc * 26 + char.charCodeAt(0) - 64, 0)
        const row = parseInt(match[2], 10)
        return [row, col]
    }

    setCellValue(worksheet, row, col, value, styles) {
        if (!worksheet) return
        const cell = worksheet.getCell(row, col)
        cell.value = value
        if (styles) {
            this._applyCellStyle(cell, styles)
        }
        if (styles && styles['height']) {
            worksheet.getRow(row).height = styles.height
        }
    }
}

export default ExcelController
